module.exports = __webpack_public_path__ + "static/media/observe_ie.86633ca2.png";